<template>
    <div v-if="visible">
        <el-dialog title="学校设置" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="800px">    
            
            <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
                <el-tab-pane label="自动升班设置" name="first">
                    <child1 v-if="activeName == 'first'"></child1>
                </el-tab-pane>

                <el-tab-pane label="设置学段" name="second">
                    <child2 v-if="activeName == 'second'"></child2>
                </el-tab-pane>

            </el-tabs>
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import setclass from './setclass/List'; 
    import setgrade from './setgrade/List';

    export default {
        components:{
            child1:setclass,
            child2:setgrade,
        },
        data(){
            return{
                visible: false,
                form:{
                },
                //默认第一个选项卡
                activeName: "first",
                data:[]
            }
        },
        methods:{
            init(data){
                this.visible=true;
                // 初始位置
                this.activeName="first";
            },
            dialogClose(done){
                done();
                // this.$reload;
                this.$parent.getData();
            },
            handleClick(tab) {
                this.activeName=tab.name;
            }
        },
        mixins: [http]
    }

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/page/sys/dept/SetSchoolMain.vue